import * as React from "react";
import { LabelProps } from "./Label.types";

function Label(props: LabelProps) {
    return (
        <label className="tmp-label">
            <div className="tmp-label-text">{props.label}</div>
            {props.children}
        </label>
    );
}

export default Label;
